import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.mjs?worker&url";

let pdfjsPromise = null;

export default function loadPdfjs() {
    if (!pdfjsPromise) {
        pdfjsPromise = import("pdfjs-dist/build/pdf.mjs").then((pdfjs) => {
            pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

            return pdfjs;
        });
    }

    return pdfjsPromise;
}
